import ApplyFromThirdParty from './apply-job';

export default ApplyFromThirdParty;
